module.exports = __webpack_public_path__ + "static/media/VV 22.9baa4691.mp3";